import { ApiReport } from "../api/ApiReport";


export const luggageCount = async (model) => {
  try {
    const data  = await ApiReport().getLuggageCount(model);

    if (data.success) {
      return { success: true, data: data.response };
    } else {
      return { success: false, data: data.errors };
    }
  } catch (error) {
    return { success: false, data: error };
  }
};